import sx from 'utils/createSx';

export default sx({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: 'text.primary',
    width: '100%',
  },
  backSlot: { flex: 1 },
  title: { flex: 1 },
});
